import { BaseIP } from "../CommonAPI/CommonApi";

//==========SALES ITEM WISE REPORT======================
export const GetSalesItemWiseReportData = BaseIP +"reports/salesReport/generateSalesItemWiseReport"  //Get Sales Item Wise Report Data (params=>  ?orderNumberIdFrom=52&orderNumberIdTo=65)

//==========SALES DETAILS REPORT======================
export const GetSalesDetailReportData = BaseIP +"reports/salesReport/generateSalesDetailsReport"  //Get Sales Details Report Data (params=>  ?orderNumberIdFrom=52&orderNumberIdTo=65)

//==========PACKING LIST REPORT======================
export const GetPackingListReportData = BaseIP +"reports/salesReport/generatePackingListReport"  //Get Packing List Report Data (params=>  ?orderNumberId=52&withRate=65)

export const GetOrderNoData = BaseIP +"sales/orderDetails/getOrderDetailsData"  //Get Order No Data

//==========ITEM STOCK REPORT======================
// export const GetItemStockReportData = BaseIP +"reports/salesReport/generateItemStockReport"  //Get Item Stock Report Data (params=>  ?dieNameId=5&allocation=2)

export const GetItemStockReportData = BaseIP +"reports/salesReport/getItemStockReportData"  //Get Item Stock Report Data (params=>  ?dieNameId=5&allocation=2)

export const GetItemNameData = BaseIP +""  //Get Item Name Data

//==========RACK RELEASE REPORT======================
export const GetRackReleaseReportData = BaseIP +""  //Get Rack Release Report Data (params=>  ?rackNo=1)
